import { render, staticRenderFns } from "./EditFolderBlockOther.vue?vue&type=template&id=76310bb8&scoped=true"
import script from "./EditFolderBlockOther.vue?vue&type=script&lang=js"
export * from "./EditFolderBlockOther.vue?vue&type=script&lang=js"
import style0 from "./EditFolderBlockOther.vue?vue&type=style&index=0&id=76310bb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76310bb8",
  null
  
)

export default component.exports